var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Stage"},[_c('p',{staticClass:"text__psb"},[_vm._v(_vm._s(_vm.$i18n.t('lb_stage')))]),_c('div',{staticClass:"sp__v"}),_c('div',{staticClass:"Stage__info text__psb"},[_vm._v(_vm._s(_vm.stage))])])}
var staticRenderFns = []

export { render, staticRenderFns }